import { createAsyncAction } from "../actionCreators";
import { API } from "@thenounproject/lingo-core";
import { FigmaIntegrationStatus } from "./useFigmaIntegrationStatus";

type Args = {
  spaceId: number;
  key: string;
};

const [useUpdateFigmaApiKey, updateFigmaApiKey] = createAsyncAction(
  "figma/updateFigmaApiKey",
  async ({ spaceId, key }: Args) => {
    return await API.call<FigmaIntegrationStatus>({
      endpoint: `spaces/${spaceId}/figma/auth`,
      method: "POST",
      data: { api_key: key },
      normalize: false,
    });
  }
);

export default useUpdateFigmaApiKey;
export { updateFigmaApiKey };
